import { render } from "./layout-horizontal-box.vue?vue&type=template&id=7d18fa12&scoped=true"
import script from "./layout-horizontal-box.vue?vue&type=script&lang=js"
export * from "./layout-horizontal-box.vue?vue&type=script&lang=js"

import "./layout-horizontal-box.vue?vue&type=style&index=0&id=7d18fa12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d18fa12"]])

export default __exports__